const Fields = () => import('./Fields')

export default function install(Vue) {
  Vue.component('delivery-fields', Fields)
}
